import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OrderWithShopName } from '@/types';

interface OrdersState {
  orders: OrderWithShopName[];
}

const initialState: OrdersState = {
  orders: [],
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders(state, action: PayloadAction<OrderWithShopName[]>) {
      state.orders = action.payload;
    },
  },
});

export const { setOrders } = ordersSlice.actions;
export default ordersSlice.reducer;
